import React, { useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';

const AddCategoryModal = ({ isOpen, setIsOpen, fetchData }) => {

    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    let [allcategory, SetCategory] = useState({
        category: "",
        status: "",
        position: "",
        user_id: isLoggedIn.user_id
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        SetCategory(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleStatusChange = (selectedOption) => {
        SetCategory(prevData => ({
            ...prevData,
            status: selectedOption ? selectedOption.value : ""
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`https://100real.xyz/category/addcategory`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(allcategory)
            });
            const res = await response.json();

            if (response.status === 200) {
               
                SetCategory({
                    category: "",
                    status: "",
                    position: "",
                    user_id: isLoggedIn.user_id
                })

                fetchData()
                toast.success("Category added successfully!", {
                    position: "top-center",
                    autoClose: 2000, // Close toast after 3 seconds
                });
                setIsOpen(false); // Close modal after submission
                // Hide alert after 3 seconds (optional)
            }
            if (response.status === 400) {
                toast.error(res.message, {
                    position: "top-center",
                    autoClose: 2000, // Close toast after 3 seconds
                });
            }
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });
         
        }
    };


    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ];

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Home Category</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="service" className="oms-form-label">
                            Category
                        </label>
                        <input type="text" name='category' id="service" value={allcategory.category} placeholder="Enter Category" onChange={handleChange} required/>
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select options={statusOptions}
                            placeholder="Select status"
                            value={statusOptions.find(option => option.value === allcategory.status)}
                            onChange={handleStatusChange} 
                            required/>
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="service" className="oms-form-label">
                            Position
                        </label>
                        <input type="text" id="service" name='position' placeholder="Enter Position" value={allcategory.position} onChange={handleChange} 
                        required/>
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddCategoryModal;
